/* global axios */
import ApiClient from './ApiClient';

class CatalogProductsAPI extends ApiClient {
  constructor() {
    super('products', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }
}

export default new CatalogProductsAPI();
